<template>
	<div>
		<h2>基础服务费</h2>
		<el-divider></el-divider>
		<el-form ref="form" :model="form" label-width="80px">
			<el-form-item label="所属平台:">
				<el-radio-group v-model="form.platform" @change="baseChange">
					<el-radio :label="item.id.toString()" v-for="item in platform_list" border>{{item.name}}</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="国家地区:">
				<el-radio-group v-model="form.country" @change="baseChange">
					<el-radio :label="item.id.toString()" v-for="item in country_list" border>{{item.name}}</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="country_name" label="国家地区"></el-table-column>
			<el-table-column prop="platform_name" label="平台"></el-table-column>
			<el-table-column prop="min_money" label="范围 (商品价格为人民币)">
				<template slot-scope="{row}">
					<span>{{row.min_money}}(元) < 商品价格 ≤ {{row.max_money}}(元)</span>
				</template>
			</el-table-column>
			<el-table-column prop="seller_cost" label="资费(元)"></el-table-column>
		</el-table>

		<h2>国家汇率</h2>
		<el-divider></el-divider>
		<el-row style="font-size: 15px;">
			<el-col :span="4" v-for="item in country_list">{{item.name}}: <span
					style="color: #409EFF;">{{item.exchange_rate}}</span></el-col>
		</el-row>
		<h2>增值服务</h2>
		<el-divider></el-divider>
		<el-row style="font-size: 15px;">
			<el-col :span="6" v-for="item in s_cost_list">{{item.name}}: <span
					style="color: #409EFF;"> {{item.price}}</span><span> {{item.unit}}</span></el-col>
		</el-row>
	</div>
</template>

<script>
	import Qs from 'qs'
	import {
		baseCostList,
		platformList,
		countryList,
		sCostList,
		costList
	} from '@/api/jd_task'
	export default {
		data() {
			return {
				form: {
					platform: "1",
					country: "2",
				},
				tableData: [],
				platform_list: [],
				country_list: [],
				s_cost_list:[],
			};
		},
		created() {
			this.getCost()
			this.getBaseCost()
		},
		methods: {
			// 获取基本服务费
			getBaseCost() {
				let post = {
					'platform_id': this.form.platform,
					'country_id': this.form.country,
				}
				baseCostList(Qs.stringify(post)).then(response => {
					this.tableData = response.result;
				})
			},
			// 获取收费标准
			getCost() {
				costList().then(response => {
					this.country_list = response.result.country;
					this.platform_list = response.result.platform;
					this.s_cost_list = response.result.sCost;
				})
			},
			baseChange() {
				this.getBaseCost()
			}
		}
	}
</script>

<style>
	.el-radio{
		margin-right: 0px;
	}
</style>
